import type { Campaign } from '../types';

import { isCampaignDifferent } from '~/modules/campaign-template';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useCampaignStore } from '../stores';
import { useTransientState } from '~/hooks';
import { useMemo } from 'react';

export const useCampaignTemplateCheckState = <T extends Campaign>(campaign: T | undefined) => {
  const { isShowDiscard } = useDiscardCheck<T>(campaign);
  const isDisabledEditing = useMemo(() => {
    if (!campaign?.status) return true;

    return [CAMPAIGN_STATUS.STOPPED, CAMPAIGN_STATUS.COMPLETED].includes(campaign.status);
  }, [campaign?.status]);

  return { isShowDiscard, isDisabledEditing };
};

export const useDiscardCheck = <T extends Campaign>(campaign: T | undefined) => {
  const storeCampaigns = useCampaignStore((state) => state.campaigns);
  const campaignCheck = useMemo(() => {
    if (!campaign?.id || !storeCampaigns) return;

    return storeCampaigns.find((c) => c.id === campaign.id);
  }, [campaign?.id, storeCampaigns]);

  const isShowDiscardRaw = useMemo(() => {
    if (!campaign?.id || !campaign || !campaignCheck) return false;

    return isCampaignDifferent(campaign, campaignCheck);
  }, [campaignCheck, campaign]);

  const { state: isShowDiscard } = useTransientState(isShowDiscardRaw);

  return { isShowDiscard };
};
